import axios from 'axios'
import {Logic} from '../Type'
import {Main} from '../Main'
import * as Assets from '../../Assets/Assets'
import * as Config from '../Config'
import * as Index from '../Index'
import * as moment from 'moment'

export function insertRewardShopTransaction(item: Index.RewardShopItemCheckout, 
                                            date: string,
                                            time: string,
                                            balanceStart: string,
                                            balanceEnd: string) {

  axios.post(Config.promostoreServerRst, {
    jwt: Main.Instance.IndexState.JWT,
    mail: Main.Instance.IndexState.mail,
    languages: Main.Instance.IndexState.languages,
    default_language: Main.Instance.IndexState.default_language,
    notify: Main.Instance.IndexState.notify,
    Category: Main.Instance.IndexState.category,
    namespace: Config.namespace,
    date: date,
    time: time,
    name: item.name,
    price: item.price,
    quantity: item.quantity,
    idx: item.id,
    category: item.category,
    value: item.value,
    site_id: Main.Instance.IndexState.Site,
    balance_before: balanceStart,
    balance_after: balanceEnd,
    player_id: Main.Instance.IndexState.Id
  })
  .then((response0) => {
    if (response0.data.resolved === true || response0.data.resolved === false && (response0.data.return === 'No custom' || response0.data.return === 'Empty custom')) {
        Logic.Type.New(Main.Instance.IndexState, {PointsXP: +balanceEnd, ALLOW_TRANSACTIONS: true})
    }
  })
/*
  .then((response0) => {
    // console.log ('recieved response!')
    // console.log (response0)
    if (response0.data.resolved === true || response0.data.resolved === false && (response0.data.return === 'No custom' || response0.data.return === 'Empty custom')) {
        // console.log ('decreasePointsXP!')
        decreasePointsXP(+balanceEnd)
    }
  })
*/
}

export function GetRewardShopTransactions(site:string, id:string, callback?:() => void) {
    let from: string = Main.Instance.IndexState.from_date ? moment(Main.Instance.IndexState.from_date).format(Assets.dateFormatDB).trim() : Assets.none
    let to: string = Main.Instance.IndexState.to_date ? moment(Main.Instance.IndexState.to_date).format(Assets.dateFormatDB).trim() : Assets.none
    Logic.Type.New (Main.Instance.IndexState, {countRstCalled:true})
    if (Main.Instance.SearchState.Gamification && Main.Instance.SearchState.Gamification.length > 0) {    
      let search:string = Main.Instance.SearchState.Gamification.toLowerCase()
      axios.get(Config.promostoreServerRstc + '?site_id='  + site + '&player_id=' + id + '&search=' + search
      + '&category=' + Main.Instance.IndexState.userCategoryValue + '&item=' + Main.Instance.IndexState.userItemValue + '&from=' + from + '&to=' + to)
      .then (response => {
        axios.get(Config.promostoreServerRst +
          '?site_id='  + site +
          '&player_id=' + id +
          '&limit=' + Main.Instance.IndexState.pSize +
          '&offset=' + Main.Instance.IndexState.offset +
          '&search=' + search +
          '&category=' + Main.Instance.IndexState.userCategoryValue +
          '&item=' + Main.Instance.IndexState.userItemValue +
          '&from=' + from +
          '&to=' + to
        )
        .then (response2 => {
/*
          axios.get(Config.promostoreServerRstbc +
          '?site_id='  + site +
          '&player_id=' + id +
          '&search=' + search +
          '&category=' + Main.Instance.IndexState.userCategoryValue +
          '&item=' + Main.Instance.IndexState.userItemValue +
          '&from=' + from +
          '&to=' + to
          )
          .then (response3 => {
            axios.get(Config.promostoreServerRstb +
            '?site_id='  + site +
            '&player_id=' + id +
            '&limit=' + Main.Instance.IndexState.pSize +
            '&offset=' + Main.Instance.IndexState.offset +
            '&search=' + search +
            '&category=' + Main.Instance.IndexState.userCategoryValue +
            '&item=' + Main.Instance.IndexState.userItemValue +
            '&from=' + from +
            '&to=' + to        
        )
            .then (response4 => {
              axios.get(Config.promostoreServerRsta +
              '?site_id='  + site +
              '&player_id=' + id +
              '&search=' + search +
              '&category=' + Main.Instance.IndexState.userCategoryValue +
              '&item=' + Main.Instance.IndexState.userItemValue +
              '&from=' + from +
              '&to=' + to            
            )
              .then (response5 => {
*/
                Logic.Type.New (Main.Instance.IndexState, {
                  countRstCalled: false,
                  count: parseInt(response.data.count),
                  rstStream: response2.data,
                  // RstStream: response4.data,
                  // RSTStream: response5.data,
                  // Count: parseInt(response3.data.count), 
                })
              // }).catch ((err) => console.log(err))
            // }).catch ((err) => console.log(err))
          // }).catch ((err) => console.log(err))

                if (callback) callback()
        }).catch ((err) => console.log(err))
      }).catch ((err) => console.log(err))            
    } else {
      axios.get(Config.promostoreServerRstc +'?site_id='  + site + '&player_id=' + id + 
      '&category=' + Main.Instance.IndexState.userCategoryValue + '&item=' + Main.Instance.IndexState.userItemValue + '&from=' + from + '&to=' + to
    )
    .then (response => {
      axios.get(Config.promostoreServerRst +
        '?site_id='  + site +
        '&player_id=' + id +
        '&limit=' + Main.Instance.IndexState.pSize +
        '&offset=' + Main.Instance.IndexState.offset + 
        '&category=' + Main.Instance.IndexState.userCategoryValue + '&item=' + Main.Instance.IndexState.userItemValue + '&from=' + from + '&to=' + to    
    )
      .then (response2 => {
/*
        axios.get(Config.promostoreServerRstbc +
        '?site_id='  + site +
        '&player_id=' + id +
        '&category=' + Main.Instance.IndexState.userCategoryValue + '&item=' + Main.Instance.IndexState.userItemValue + '&from=' + from + '&to=' + to    
        )
        .then (response3 => {
          axios.get(Config.promostoreServerRstb +
            '?site_id='  + site +
            '&player_id=' + id +
            '&limit=' + Main.Instance.IndexState.pSize +
            '&offset=' + Main.Instance.IndexState.offset +
            '&category=' + Main.Instance.IndexState.userCategoryValue + '&item=' + Main.Instance.IndexState.userItemValue + '&from=' + from + '&to=' + to        
        )
          .then (response4 => {
*/
            axios.get(Config.promostoreServerRsta +
              '?site_id='  + site +
              '&player_id=' + id +
              '&category=' + Main.Instance.IndexState.userCategoryValue +
              '&item=' + Main.Instance.IndexState.userItemValue +
              '&from=' + from + 
              '&to=' + to
            )
            .then (response5 => {

              if (+Main.Instance.IndexState.userCategoryValue === 0 && +Main.Instance.IndexState.userItemValue === 0 && from === Assets.none && to === Assets.none) {
                let userItem: any[] = []
                for (const item of Main.Instance.IndexState.allPlayerRst) {
                    if (item === undefined) continue
                    let proceed: boolean = true
                    for (const Item of userItem) {
                        if (item.idx === Item.id) {
                            proceed = false
                            break
                        }
                    }
                    if (proceed) {
                        userItem.push({id: item.idx, name: item.item_name, category: item.category})
                    }
                }
                userItem.sort(compare)

                let userCategory: any[] = []
                for (const item of response5.data) {
                    if (item === undefined) continue
                    let proceed: boolean = true
                    for (const Item of userCategory) {
                        if (item.category === Item.id) {
                            proceed = false
                            break
                        }
                    }
                    if (proceed) {
                        userCategory.push({id: item.category, name: Main.Instance.IndexState.category[
                            Main.Instance.IndexState.languages.length * (item.category) + Main.Instance.IndexState.default_language
                        ]})
                    }
                }
                userCategory.sort(compare)

                Logic.Type.New (Main.Instance.IndexState, {
                    userCategory,
                    userItem,
                    countRstCalled: false,
                    rstStream: response2.data,
                    // RstStream: response4.data,
                    RSTStream: response5.data,
                    count: parseInt(response.data.count), 
                    // Count: parseInt(response3.data.count),
                })
              } else {
                Logic.Type.New (Main.Instance.IndexState, {
                    countRstCalled: false,
                    rstStream: response2.data,
                    // RstStream: response4.data,
                    RSTStream: response5.data,
                    count: parseInt(response.data.count),
                    // Count: parseInt(response3.data.count),
                })                    
              }
            // })
          // })
            })          
            if (callback) callback()
      }).catch ((err) => console.log(err))
    }).catch ((err) => console.log(err))
  }
}

export function compare(a,b) {
    if (a.name < b.name)
      return -1;
    if (a.name > b.name)
      return 1;
    return 0;
  }

export function insertPointsXP (username:string, id:string, site:string, credits:number) {
  axios.patch(Config.promostoreServerPlayerPointsXp, {
    namespace: Config.namespace,
    site_id: Main.Instance.IndexState.Site,
    player_id: Main.Instance.IndexState.Id,
  })
  .then(response => {
    if (parseInt(response.data.count) === 1) {

      let newBalance: number = credits + parseInt(Main.Instance.IndexState.PointsXP.toString())
      let newBalancl: number = credits + parseInt(Main.Instance.IndexState.PointsXPL.toString())
      
      updatePointsXP(newBalance, newBalancl)

      Logic.Type.New (Main.Instance.IndexState, {PointsXP: newBalance, PointsXPL: newBalancl})
    } else if (parseInt(response.data.count) === 0) {
      axios.post(Config.promostoreServerPointsXp, {
        namespace: Config.namespace,
        site_id: Main.Instance.IndexState.Site,
        player_id: Main.Instance.IndexState.Id,
        credits: credits
      })
      Logic.Type.New (Main.Instance.IndexState, {PointsXP: credits, PointsXPL: credits})
    }
  }).catch ((err) => console.log(err))
  }

function UpdatePointsXP(balance:number, balancl:number) {
  axios.put(Config.promostoreServerPointsXp, {
    namespace: Config.namespace,
    site_id: Main.Instance.IndexState.Site,
    player_id: Main.Instance.IndexState.Id,
    balance: balance.toString(),
    balancl: balancl.toString()
  })
}

export function updatePointsXP(balance:number, balancl:number) {
  UpdatePointsXP(balance, balancl)
}

export function resetTotalAndAvailablePoints() {
  UpdatePointsXP(0, 0)
}
/*
export function decreasePointsXP(balance: number) {
    // console.log (Main.Instance.IndexState.Id)
    // console.log (balance)
    
    axios.patch(Config.promostorePlayerStatsXPlXP, {
      // namespace: Config.namespace,
      // site_id: Main.Instance.IndexState.Site,
      player: Main.Instance.IndexState.Id,
      balance: balance.toString()
    })
  }
*/
/*
export function deductPointsXP(balance: number) {
  axios.patch(Config.promostoreServerPointsXp, {
    namespace: Config.namespace,
    site_id: Main.Instance.IndexState.Site,
    player_id: Main.Instance.IndexState.Id,
    balance: balance.toString()
  })
}
*/
/*
export function getPoints() {
  axios.post(Config.localServer + '/get/points', {
    namespace: Config.namespace,
    site_id:Main.Instance.IndexState.Site,
  })
  .then(response => {
    if (response.data) {
      Logic.Type.New (Main.Instance.IndexState, {Points:response.data, PointsCountCalled:false})
    }
  }).catch ((err) => alert(err))
}
*/
export function getShopItems() {
  axios.get(Config.promostoreServerShopItems + '?site_id=' + Main.Instance.IndexState.Site
  + '&sort_active=' + Main.Instance.IndexState.sortActive
  + '&sort_price=' + Main.Instance.IndexState.sortPrice
  + '&sort_name=' + Main.Instance.IndexState.sortName
  + '&sort_discount=' + Main.Instance.IndexState.sortDiscount)  
  .then(response2 => {
    let shopItems: Index.ShopItem[] = []
    // let shopItemsBought:number[] = []

    for (let i:number = 0; i < response2.data.length; i++) {
      let title: string = response2.data[i].title.toString() 
      let active:boolean
      if (Main.Instance.SearchState.Gamification.length > 0 && -1 ===
          title.toLowerCase().indexOf(Main.Instance.SearchState.Gamification.toLowerCase())) {
        active = false
      } else {
        active = true
      }
      // console.log (response2.data[i].id)

      shopItems.push({
        fromtime: response2.data[i].fromtime,
        totime: response2.data[i].totime,
        id: response2.data[i].id,
        players: response2.data[i].players,
        multi: response2.data[i].buyable,
        newly: response2.data[i].only_newly_registered,
        free_round: response2.data[i].free_round,
        title: response2.data[i].title,
        active: active && response2.data[i].active,
        image: response2.data[i].image && response2.data[i].image.length > 0 ?
        response2.data[i].image : Config.adminServerLogo + Main.Instance.IndexState.Site + '/shop.jpg',
        price: parseInt(response2.data[i].price),
        banner: parseInt(response2.data[i].banner),
        category: parseInt(response2.data[i].category),
        info: response2.data[i].info2,
        t_c: response2.data[i].info,
        idx: i,
        index: parseInt(response2.data[i].index),
        discountedPrice: parseInt(response2.data[i].discountedprice),
        discount: parseInt(response2.data[i].discount)
      })
      // shopItemsBought.push(0)
    }
  
    Logic.Type.New(Main.Instance.IndexState, {
      shopItems: shopItems,
      // shopItemsBought: shopItemsBought
    })
    // getRewardShopTransactions()
  }).catch ((err) => console.log(err))
}


// WEBPACK FOOTER //
// ./src/Logic/Database/app.ts